import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);
  const inflight = useRef(null);

  const check = useCallback(() => {
    if (inflight.current) return inflight.current;
    inflight.current = (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        try {
          await api.post("/auth/refresh");
          const { data } = await api.get("/auth/me");
          setUser(data);
        } catch {
          setUser(false);
        }
      }
      setChecked(true);
    })();
    return inflight.current;
  }, []);

  useEffect(() => {
    if (window.location.pathname.startsWith("/admin")) check();
  }, [check]);

  const ensure = useCallback(() => {
    if (!checked) check();
  }, [checked, check]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    setChecked(true);
  };
  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout, ensure }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
